var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-qrcode",
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#000000",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17l0 .01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7l0 .01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7l0 .01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14l3 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14l0 .01"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14l0 3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20l3 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17l3 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17l0 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.a037bc9ca70d071962608e679ee5765c.svg";
export { ForwardRef as ReactComponent };